import { useEffect } from 'react';
/* eslint-disable consistent-return */

/*
A React hook to load an external script

Example usage

  import useScript from '../utils/hooks/useScript';

  const UsefulComponent = () => {
    useScript('https://example-library.js');
    return <p>Howdy</p>;
  };
*/

var useScript = function useScript(url) {
  useEffect(function () {
    var script = document.createElement('script');
    script.src = url;
    script.async = true;
    document.body.appendChild(script);
    return function () {
      document.body.removeChild(script);
    };
  }, [url]);
};

export default useScript;